// ============================================================================
// Cliente das Edge Functions. O front NUNCA fala com n8n direto — só com as
// functions, que guardam os tokens server-side.
// ============================================================================

import { supabase } from "./supabase";
import type { ChatMessage, IntakeResponse, ResolveGrupoResponse } from "./types";
import type { DadosContrato } from "./contratoSchema";

export interface IntakePayload {
  messages: ChatMessage[];
  handoff?: { termos_notas?: string | null; plano_acordado?: string | null; valor_acordado?: number | null; nome_cliente?: string | null } | null;
  dados?: Partial<DadosContrato>;
  confirm?: boolean;
}

/** Conversa de criação de contrato (Gemini server-side + disparo do wrapper). */
export async function callContractIntake(payload: IntakePayload): Promise<IntakeResponse> {
  const { data, error } = await supabase.functions.invoke<IntakeResponse>("contract-intake", {
    body: payload,
  });
  if (error) {
    return { status: "erro", message: error.message };
  }
  if (!data) return { status: "erro", message: "Resposta vazia da função." };
  return data;
}

/** Dispara o sync de status do D4Sign (proxy autenticado p/ webhook n8n). */
export async function callSyncStatus(): Promise<{ ok: boolean; message?: string }> {
  const { data, error } = await supabase.functions.invoke<{ ok: boolean; message?: string }>(
    "d4sign-sync",
    { body: {} }
  );
  if (error) return { ok: false, message: error.message };
  return data ?? { ok: false, message: "Resposta vazia." };
}

/**
 * Resolve um grupo WhatsApp pelo link de convite: a Edge Function usa a
 * instância Z-API (Yuri) p/ puxar o metadado, cadastra em `grupos` e devolve
 * { grupo_id, nome, grupo_link }.
 */
export async function resolveWhatsappGroup(invite_link: string): Promise<ResolveGrupoResponse> {
  const { data, error } = await supabase.functions.invoke<ResolveGrupoResponse>(
    "whatsapp-group-resolve",
    { body: { invite_link } }
  );
  if (error) return { ok: false, message: error.message };
  return data ?? { ok: false, message: "Resposta vazia da função." };
}
